export default __webpack_public_path__ + "static/media/black-close.d9c9ed80.svg";